const setAppEnv = (Vue, environment) => {
  const isDevelopment = !['production', 'staging'].includes(environment)
  const isProduction = environment === 'production'
  Vue.appEnv = {
    environment,
    isProduction,
    isDevelopment
  }
}

const AppEnvironmentPlugin = {
  install (Vue) {
    const environment = process.env.VUE_APP_ENVIRONMENT
    setAppEnv(Vue, environment)
  }
}

export default AppEnvironmentPlugin

export { setAppEnv }
